module.exports = "/_next/static/images/payment-fc00a61e193524aef8e317f717d05443.svg";